"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _style = require("./style");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
class Search extends _react.default.Component {
  constructor() {
    super(...arguments);
    this.state = {
      search: ''
    };
    this.updateSearch = search => {
      this.setState({
        search
      });
    };
    this.onChange = event => {
      const {
        onChange
      } = this.props;
      const search = event.target.value;
      onChange(search);
      this.updateSearch(search);
    };
    this.clearSearch = () => {
      const {
        onChange
      } = this.props;
      onChange('');
      this.updateSearch('');
    };
    this.handleEnterKeyPress = event => {
      event.stopPropagation();
      event.nativeEvent.stopImmediatePropagation();
      const {
        onEnterKeyPress
      } = this.props;
      const {
        search
      } = this.state;
      if (event.key === 'Enter' && onEnterKeyPress) {
        event.preventDefault();
        onEnterKeyPress(search);
      }
    };
  }
  componentDidUpdate(prevProps) {
    if (prevProps.isOpen !== this.props.isOpen) {
      setTimeout(() => this.inputRef.focus(), 50);
    }
  }
  render() {
    const {
      placeholder,
      onClick,
      height,
      clearSearchOnBlur,
      clearSearchOnFocus
    } = this.props;
    const {
      search
    } = this.state;
    return /*#__PURE__*/_react.default.createElement(_style.SearchWrapper, null, /*#__PURE__*/_react.default.createElement(_style.SearchInput, {
      placeholder: placeholder,
      type: "text",
      value: search,
      ref: inputRef => this.inputRef = inputRef,
      onChange: event => this.onChange(event),
      onClick: onClick,
      onBlur: clearSearchOnBlur ? this.clearSearch : undefined,
      onFocus: clearSearchOnFocus ? this.clearSearch : undefined,
      height: height,
      onKeyUp: this.handleEnterKeyPress
    }));
  }
}
exports.default = Search;
Search.propTypes = {
  placeholder: _propTypes.default.string,
  onChange: _propTypes.default.func.isRequired,
  isOpen: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  height: _propTypes.default.string,
  clearSearchOnBlur: _propTypes.default.bool,
  clearSearchOnFocus: _propTypes.default.bool,
  onBlur: _propTypes.default.func,
  onEnterKeyPress: _propTypes.default.func
};
Search.defaultProps = {
  placeholder: '',
  height: 'tall',
  isOpen: false,
  clearSearchOnBlur: false,
  clearSearchOnFocus: false,
  onClick: () => {},
  onBlur: () => {},
  onEnterKeyPress: undefined
};